import React from 'react';
import classnames from 'classnames';

import { eventOn, eventOff } from '../../helpers/global';

import '../../sass/components/common/NotificationPopup.scss';

const SHOW_TIME = 5000;

class NotificationPopup extends React.Component {
  constructor(props) {
    super();
    this.state = {
      show: false,
      title: null,
      text: null,
    };
    this.timeout = null;
  }

  componentDidMount = () => {
    eventOn('showNotification', this.showNotification);
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
    eventOff('showNotification', this.showNotification);
  }

  showNotification = (e) => {
    clearTimeout(this.timeout);
    const { title, text, type = null } = e.detail[0];
    this.setState({show: true, title, text, type});
    this.timeout = setTimeout(this.onClose, SHOW_TIME);
  }

  onClose = () => {
    clearTimeout(this.timeout);
    this.setState({show: false});
  }

  render = () => {
    const { show, title, text, type } = this.state;
    return (
      <div
        className={classnames({
          'notificationPopup': true,
          'show': show,
          [type]: !!type,
        })}
      >
        <div className='notificationContainer'>
          <div className='notificationTitle' dangerouslySetInnerHTML={{__html: title || ''}}/>
          <div className='notificationText' dangerouslySetInnerHTML={{__html: text || ''}}/>
          <div
            onClick={this.onClose}
            className='notificationClose'
          />
        </div>
      </div>
    )
  }
}

export default NotificationPopup;
